import React, { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import "./App.css";


// Import components
import LoginPage from "./components/LoginPage";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";
import CourseViewer from "./components/CourseViewer";
import HeroPage from "./components/HeroPage";
import Assessment from "./components/Assessment";
import AssessmentsList from "./components/AssessmentsList";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
console.log(API)

// Auth Context
const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

// Auth Provider Component
const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      getCurrentUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const getCurrentUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data);
    } catch (error) {
      console.error("Error getting current user:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    console.log(API)
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password
      });
      
      const { access_token, user: userData } = response.data;
      setToken(access_token);
      setUser(userData);
      localStorage.setItem("token", access_token);
      
      toast.success("Login realizado com sucesso!");
      return { success: true };
    } catch (error) {
      console.log(error);
      const message = error.response?.data?.detail || "Erro no login";
      toast.error(message);
      return { success: false, message };
    }
  };

  const register = async (userData) => {
    try {
      await axios.post(`${API}/auth/register`, userData);
      
      // Show detailed success message
      toast.success(
        "Cadastro realizado com sucesso! Para acessar a Escola de Suporti, aguarde a aprovação de um gestor.",
        {
          duration: 8000,
          style: {
            background: '#dcfce7',
            border: '1px solid #16a34a',
            color: '#15803d',
            fontSize: '14px',
            padding: '16px'
          }
        }
      );
      
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || "Erro no registro";
      toast.error(message);
      return { success: false, message };
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    toast.info("Logout realizado");
;
  };

  const value = {
    user,
    token,
    login,
    register,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    
    return <Navigate to="/home" />;
  }

  if (adminOnly && !["admin", "coordinator"].includes(user.role)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

// Main App Component
function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>

            

            {/* <Route path="/login" element={<HeroPage />} /> */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/home" element={<HeroPage />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute adminOnly={true}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/course/:courseId" 
              element={
                <ProtectedRoute>
                  <CourseViewer />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/assessments" 
              element={
                <ProtectedRoute>
                  <AssessmentsList />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/assessment/:assessmentId" 
              element={
                <ProtectedRoute>
                  <Assessment />
                </ProtectedRoute>
              } 
            />
            
            <Route path="/avaliacoes" element={<Navigate to="/assessments" />} />
            <Route path="/" element={<Navigate to="/home" />} />
          </Routes>
        </BrowserRouter>
        
        <Toaster 
          position="top-right"
          richColors
          closeButton
        />
      </div>
    </AuthProvider>
  );
}

export default App;